/**
 * Created by charnjeetelectrovese@gmail.com on 12/5/2018.
 */
import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";

// Lazy-loaded route components for better code splitting (reduces main bundle by ~200-300KB)
// Each route is loaded only when user navigates to it
const Dashboard = lazy(() => import("../layouts/Dashboard/Dashboard.jsx"));
const LoginView = lazy(() => import("../views/Login/LoginForm/Login.view.js"));
const ForgotPassword = lazy(() => import("../views/ForgotPassword/Forgot/ForgotPassword.view.js"));
const ResetPassword = lazy(() => import("../views/ForgotPassword/ResetPassword.view.js"));
const HorizontalNav = lazy(() => import("../views/HorizontalNav/HorizontalNav.js"));
const DragDrop = lazy(() => import("../views/DragDrop/DragDrop.jsx"));
const ChooseAccount = lazy(() => import("../views/ChooseAccount/ChooseAccount.js"));
const SuccessPageView = lazy(() => import("../views/PasswordSucessful/SucessPage.view.js"));
const FirstResetPassowrd = lazy(() => import("../views/ForgotPassword/FirstResetPassword/FirstResetPassword.component.js"));
const ResetPasswordView = lazy(() => import("../views/ResetPasswordPage/ResetPassword.component.js"));
const PublicWebformPage = lazy(() => import("../views/Webforms/PublicWebformPage.js"));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    fontSize: '18px',
    color: '#666'
  }}>
    Loading...
  </div>
);

const RouteComponent = () => (
  <Suspense fallback={<LoadingFallback />}>
    <Switch>
      <Route path={"/login"} component={LoginView} />
      <Route path={"/forgot/password"} component={ForgotPassword} />
      <Route path={"/tester"} component={HorizontalNav} />
      <Route path={"/drag"} component={DragDrop} />
      <Route path={"/already"} component={ChooseAccount} />
      <Route path={"/password/resend"} component={SuccessPageView} />
      <Route path={"/reset/password"} component={FirstResetPassowrd} />
      <Route path={"/password/reset"} component={ResetPasswordView} />
      <Route path={"/f/:slug"} component={PublicWebformPage} />

      <Route path={"/"} component={Dashboard} />
    </Switch>
  </Suspense>
);
export default RouteComponent;
